import React, { useState, useEffect, useContext } from "react";

import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import FormControl from "@material-ui/core/FormControl";

import axios from "axios";
import Swal from "sweetalert2";
import { useLocation, useHistory } from "react-router-dom";

import Card from "@material-ui/core/Card";
import MenuItem from "@material-ui/core/MenuItem";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import LinearProgress from "@material-ui/core/LinearProgress";
import Checkbox from "@material-ui/core/Checkbox";
import { SketchPicker } from "react-color";

import Sidebar from "../../components/Sidebar";
import { AuthContext } from "../../context/AuthContext";
import placeholder from "../../assets/images/placeholder.png";

const useStyle = makeStyles({
  fieldWrapper: {
    display: "flex",
    marginBottom: 30,
  },
  fieldName: {
    flexGrow: 1,
    marginTop: 11,
    width: 100,
  },
  fieldInput: {
    flexGrow: 3,
    width: 200,
  },
  input: {
    padding: "5px",
    height: 45,
    borderRadius: 15,
  },
  select: {
    "& .MuiSelect-select:focus": {
      backgroundColor: "#fff",
    },
    padding: "5px",
    height: 45,
    borderRadius: 15,
  },
  margin: {
    marginBottom: 20,
  },
  textarea: {
    borderRadius: 15,
  },
  buttonStyle: {
    padding: " 10px 30px",
    fontSize: 14,
    borderRadius: "25px",
    marginLeft: 20,
  },
  buttonWeraper: {
    marginTop: 25,
    float: "right",
  },
  styleCancel: {
    color: "#999",
  },
  padding: {
    padding: 30,
  },
  label: {
    backgroundColor: "indigo",
    color: "white",
    padding: "0.5rem",
    borderRadius: "0.3rem",
    cursor: "pointer",
    marginTop: "1rem",
  },
  mrgin_right: {
    marginRight: 25,
  },
});

const UpdateShopPromos = () => {
  const classes = useStyle();
  const location = useLocation();
  const history = useHistory();
  const row = location.state;

  const [title, set_title] = useState("");
  const [details, set_details] = useState("");
  const [status, set_status] = useState(0);
  const [banner, setBanner] = useState("");
  const [app_for, set_app_for] = useState("");
  const [link, set_link] = useState("");
  const [attachment, set_attachment] = useState();
  const [submitType, setSubmitType] = useState("");
  const [loading, setLoading] = useState(false);

  const { auth } = useContext(AuthContext);



  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const data = new FormData();
      if (attachment) {
        const imagedata = attachment;
        data.append("attachment", imagedata);
      }
      data.append("title", title);
      data.append("details", details);
      data.append("shop_promo_id", row.id);
      data.append("status", status);

      if (app_for.length > 0) {
        data.append("app_for", app_for);
      } else {
        data.append("app_for", "");
      }

      data.append("app_for", app_for);
      data.append("link", link);

      let res = await axios({
        url: "/api/update-shop-promo",
        method: "post",
        data: data,
        headers: {
          Authorization: `Bearer ${auth.token}`,
          "Content-Type": "multipart/form-data",
          Accept: "application/json",
          type: "formData",
        },
      });

      if (res.data.code === 200) {
        Swal.fire({
          icon: "success",
          title: "Succesfully Saved",
          showConfirmButton: false,
          timer: 1000,
        });

        history.push("/shop-promo-list");

      } else {
        Swal.fire({
          icon: "warning",
          title: res.data.messages,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    } catch (error) {

      Swal.fire({
        icon: "warning",
        title: `${error.response.data.messages.toString()}`,
        showConfirmButton: false,
        timer: 2000,
      });
    }
    setLoading(false);
  };

  const handleCancel = () => {
    history.push("/shop-promo-list");
  };

  const initialState = () => {
    set_title(row.title);
    set_details(row.details);
    set_status(row.status);
    row.app_for && set_app_for(row.app_for);
    setBanner(row.banner);
    set_link(row.link);
  };

  const deleteBanner = async () => {
    try {
      let res = await axios({
        url: `/api/delete-shop-promo-banner`,
        method: "post",
        data: {
          'shop_promo_id': row.id,
        },
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      });

      if (res.data.code === 200) {
        Swal.fire({
          icon: "success",
          title: "Succesfully Saved",
          showConfirmButton: false,
          timer: 1000,
        });
        setBanner(false);
      } else {
        Swal.fire({
          icon: "warning",
          title: res.data.messages,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    } catch (error) {
      console.log("err", error);
    }
  };

  const imageButton = () => {
    const actualBtn = document.getElementById("actual-btn");

    const fileChosen = document.getElementById("file-chosen");

    actualBtn.addEventListener("change", function () {
      fileChosen.textContent = this.files[0].name;
    });
  };

  useEffect(() => {
    initialState();
    imageButton();

  }, []);

  return (
    <div>
      <div className="wrapper">
        <Sidebar />
        <div className="wrapper-inner">
          {/* <form onSubmit={handleSubmit} enctype="multipart/form-data"> */}
          <form onSubmit={handleSubmit}>
            <Grid container>
              <Grid item md={10} lg={8}>
                <Typography variant="h4" className={classes.margin}>
                  Update Shop Promo
                </Typography>
                <Card>
                  <CardContent className={classes.padding}>
                    <div className={classes.fieldWrapper}>
                      <div className={classes.fieldName}>
                        <Typography variant="subtitle1">Title</Typography>
                      </div>
                      <div className={classes.fieldInput}>
                        <TextField
                          id="outlined-basic"
                          placeholder="E.g. Marketing Manager"
                          variant="outlined"
                          fullWidth
                          required
                          value={title}
                          onChange={(e) => set_title(e.target.value)}
                          InputProps={{
                            className: classes.input,
                          }}
                        />
                      </div>
                    </div>
                    <div className={classes.fieldWrapper}>
                      <div className={classes.fieldName}>
                        <Typography variant="subtitle1">Banner</Typography>
                      </div>
                      <div className={classes.fieldInput}>
                        {banner ? (
                          <img
                            src={row.banner}
                            style={{ height: "100px" }}
                            alt=""
                          />
                        ) : (
                          <img
                            src={placeholder}
                            alt=""
                            style={{ height: "100px" }}
                          />
                        )}
                        <br />
                        <br />
                        <Button
                          className={classes.mrgin_right}
                          color="secondary"
                          onClick={deleteBanner}
                        >
                          Delete
                        </Button>
                        <input
                          type="file"
                          id="actual-btn"
                          accept="image/png, image/jpeg"
                          hidden
                          onChange={(e) => set_attachment(e.target.files[0])}
                          name="attachment"
                        />
                        <label for="actual-btn">
                          <Button
                            variant="contained"
                            color="primary"
                            component="span"
                            className={classes.buttonStyle}
                            style={{ marginLeft: "-0px" }}
                          >
                            Choose file
                          </Button>
                        </label>
                        <span id="file-chosen" style={{ marginLeft: 15 }}>
                          No file chosen
                        </span>
                      </div>
                    </div>

                    <div className={classes.fieldWrapper}>
                      <div className={classes.fieldName}>
                        <Typography variant="subtitle1">Details</Typography>
                      </div>
                      <div className={classes.fieldInput}>
                        <TextField
                          id="outlined-basic"
                          variant="outlined"
                          placeholder="Details"
                          required
                          multiline
                          rcurrenciesows={7}
                          rows={5}
                          fullWidth
                          value={details}
                          onChange={(e) => set_details(e.target.value)}
                          InputProps={{
                            className: classes.textarea,
                          }}
                        />
                      </div>
                    </div>
                    <div className={classes.fieldWrapper}>
                      <div className={classes.fieldName}>
                        <Typography variant="subtitle1">Status</Typography>
                      </div>
                      <div className={classes.fieldInput}>
                        <FormControl component="fieldset">
                          <RadioGroup
                            row
                            aria-label="position"
                            name="position"
                            defaultValue="top"
                          >
                            <FormControlLabel
                              value="1"
                              checked={status == 1}
                              onChange={(e) => set_status(e.target.value)}
                              control={<Radio color="primary" />}
                              label="Active"
                            />
                            <FormControlLabel
                              value="0"
                              checked={status == 0}
                              onChange={(e) => set_status(e.target.value)}
                              control={<Radio color="primary" />}
                              label="Deactive"
                            />
                          </RadioGroup>
                        </FormControl>
                      </div>
                    </div>
                   

                    <div className={classes.fieldWrapper}>
                      <div className={classes.fieldName}>
                        <Typography variant="subtitle1">Link</Typography>
                      </div>
                      <div className={classes.fieldInput}>
                        <TextField
                          required
                          placeholder="Link"
                          variant="outlined"
                          type="url"
                          fullWidth
                          value={link}
                          onChange={(e) => set_link(e.target.value)}
                          InputProps={{
                            className: classes.input,
                          }}
                        />
                      </div>
                    </div>

                    <div className={classes.fieldWrapper}>
                      <div className={classes.fieldName}>
                        <Typography variant="subtitle1">App For</Typography>
                      </div>
                      <div className={classes.fieldInput}>
                        <TextField
                          id="outlined-select-currency"
                          select
                          value={app_for}
                          onChange={(e) => set_app_for(e.target.value)}
                          variant="outlined"
                          fullWidth
                          InputProps={{
                            className: classes.select,
                          }}
                        >
                          <MenuItem value="">All</MenuItem>
                          
                          <MenuItem value="personal">Personal</MenuItem>
                        </TextField>
                      </div>
                    </div>

                  </CardContent>
                </Card>
                {loading ? (
                  <LinearProgress style={{ marginTop: 20 }} />
                ) : (
                  <div className={classes.buttonWeraper}>
                    <Button
                      className={classes.styleCancel}
                      onClick={handleCancel}
                    >
                      Cancel
                    </Button>
                    
                    <Button
                      variant="contained"
                      color="primary"
                      size="large"
                      className={classes.buttonStyle}
                      type="submit"
                      onClick={(e) => setSubmitType("add")}
                    >
                      Update Shop Promo
                    </Button>
                  </div>
                )}
              </Grid>
            </Grid>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UpdateShopPromos;
